export const objectIsEmpty = (object: object) => !Object.keys(object).length;